import phonesInfo from '@/components/phones-info/PhonesInfo'

export default [
  {
    path: '/phonesInfo',
    name: 'phonesInfo',
    component: phonesInfo,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/phonesInfoRoutes.js